/**
 * jh-product.js
 * JavaScript consolidado — JH Hero + FAQ
 * Tema: Horizon · Online Store 2.0
 *
 * Módulos incluidos:
 *  1. Galería (carrusel, cuadrícula, miniaturas, zoom)
 *  2. Sticky Add-to-Cart
 *  3. Pestañas de producto
 *  4. Cuenta regresiva
 *  5. FAQ acordeón
 *
 * NOTA: El JS de los bloques Liquid (variantes, etc.) lo gestiona
 * Shopify automáticamente vía {% javascript %} → block-scripts.js
 *
 * Carga: <script src="{{ 'jh-product.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ============================================================
     1. ZOOM MODAL
     ============================================================ */
  function abrirZoom(src) {
    if (!src) return;

    var modal = document.createElement('div');
    modal.className = 'jh-zoom-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Imagen ampliada');

    var img = document.createElement('img');
    img.src = src;
    img.alt = '';

    var btnCerrar = document.createElement('button');
    btnCerrar.className = 'jh-zoom-modal__cerrar';
    btnCerrar.setAttribute('aria-label', 'Cerrar imagen ampliada');
    btnCerrar.innerHTML = '&times;';

    modal.appendChild(img);
    modal.appendChild(btnCerrar);
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    function cerrar() {
      modal.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', manejarTecla);
    }

    function manejarTecla(e) {
      if (e.key === 'Escape') cerrar();
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) cerrar();
    });
    btnCerrar.addEventListener('click', cerrar);
    document.addEventListener('keydown', manejarTecla);
    btnCerrar.focus();
  }

  /* ============================================================
     2. GALERÍA
     ============================================================ */
  function iniciarGaleria() {
    var galeria = document.querySelector('.jh-galeria');
    if (!galeria) return;

    var modo = galeria.dataset.modo || 'carrusel';
    var miniaturas = galeria.querySelectorAll('.jh-galeria__miniatura');

    function sincronizarMiniaturas(indiceActivo) {
      miniaturas.forEach(function (m, i) {
        m.classList.toggle('is-activa', i === indiceActivo);
      });
    }

    if (modo === 'carrusel') {
      var pista      = galeria.querySelector('.jh-carrusel__pista');
      var diaps      = galeria.querySelectorAll('.jh-carrusel__diapositiva');
      var btnPrev    = galeria.querySelector('.jh-carrusel__flecha--prev');
      var btnNext    = galeria.querySelector('.jh-carrusel__flecha--next');
      var puntos     = galeria.querySelectorAll('.jh-carrusel__punto');
      var spanActual = galeria.querySelector('.jh-carrusel__actual');

      if (!pista || diaps.length === 0) return;

      var indice  = 0;
      var total   = diaps.length;
      var tocadoX = 0;

      function irA(n) {
        indice = ((n % total) + total) % total;
        pista.style.transform = 'translateX(-' + (indice * 100) + '%)';
        puntos.forEach(function (p, i) {
          p.classList.toggle('is-activo', i === indice);
          p.setAttribute('aria-selected', i === indice ? 'true' : 'false');
        });
        if (spanActual) spanActual.textContent = indice + 1;
        sincronizarMiniaturas(indice);
      }

      if (btnPrev) btnPrev.addEventListener('click', function () { irA(indice - 1); });
      if (btnNext) btnNext.addEventListener('click', function () { irA(indice + 1); });
      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () { irA(i); });
      });

      galeria.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') irA(indice + 1);
        if (e.key === 'ArrowLeft')  irA(indice - 1);
      });

      var pistaWrapper = galeria.querySelector('.jh-carrusel__pista-wrapper');
      if (pistaWrapper) {
        pistaWrapper.addEventListener('touchstart', function (e) {
          tocadoX = e.changedTouches[0].screenX;
        }, { passive: true });
        pistaWrapper.addEventListener('touchend', function (e) {
          var diff = e.changedTouches[0].screenX - tocadoX;
          if (diff < -50) irA(indice + 1);
          if (diff > 50)  irA(indice - 1);
        });
      }

      diaps.forEach(function (d) {
        var img = d.querySelector('img');
        if (img) {
          img.addEventListener('click', function () {
            abrirZoom(this.dataset.zoom || this.src);
          });
        }
      });

      miniaturas.forEach(function (m, i) {
        m.addEventListener('click', function () { irA(i); });
      });
    }

    if (modo === 'cuadricula') {
      var items = galeria.querySelectorAll('.jh-cuadricula__item');
      items.forEach(function (item, i) {
        item.addEventListener('click', function () {
          var img = this.querySelector('img');
          if (img) {
            sincronizarMiniaturas(i);
            abrirZoom(img.dataset.zoom || img.dataset.full || img.src);
          }
        });
      });
      miniaturas.forEach(function (m, i) {
        m.addEventListener('click', function () {
          sincronizarMiniaturas(i);
          abrirZoom(this.dataset.zoom || this.dataset.src);
        });
      });
    }
  }

  /* ============================================================
     3. STICKY ADD-TO-CART
     ============================================================ */
  function iniciarStickyAtc() {
    var sticky = document.querySelector('.jh-sticky-atc');
    var cta    = document.querySelector('.jh-botones-compra');
    if (!sticky || !cta) return;

    var btnSticky = sticky.querySelector('.jh-sticky-atc__btn');
    if (btnSticky) {
      btnSticky.addEventListener('click', function () {
        var btnPrincipal = document.querySelector('.jh-btn-agregar:not(:disabled)');
        if (btnPrincipal) {
          btnPrincipal.click();
          btnPrincipal.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(cta);
  }

  /* ============================================================
     4. PESTAÑAS DE PRODUCTO
     ============================================================ */
  function iniciarPestanas() {
    document.querySelectorAll('.jh-pestanas').forEach(function (cont) {
      var btns   = cont.querySelectorAll('.jh-pestanas__btn');
      var panels = cont.querySelectorAll('.jh-pestanas__panel');

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tab = this.dataset.tab;

          btns.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
            b.setAttribute('tabindex', '-1');
          });
          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');
          this.removeAttribute('tabindex');

          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', '');
          });
          var panelActivo = cont.querySelector('#jh-panel-' + tab + '-' + cont.dataset.blockId);
          if (panelActivo) {
            panelActivo.classList.add('is-active');
            panelActivo.removeAttribute('hidden');
          }
        });

        btn.addEventListener('keydown', function (e) {
          var idx      = Array.from(btns).indexOf(this);
          var siguiente = -1;
          if (e.key === 'ArrowRight') siguiente = (idx + 1) % btns.length;
          if (e.key === 'ArrowLeft')  siguiente = (idx - 1 + btns.length) % btns.length;
          if (e.key === 'Home')       siguiente = 0;
          if (e.key === 'End')        siguiente = btns.length - 1;
          if (siguiente >= 0) {
            e.preventDefault();
            btns[siguiente].click();
            btns[siguiente].focus();
          }
        });
      });
    });
  }

  /* ============================================================
     5. CUENTA REGRESIVA
     ============================================================ */
  function iniciarCuentas() {
    document.querySelectorAll('.jh-cuenta-regresiva').forEach(function (el) {
      var horas    = parseInt(el.dataset.horas || '4', 10);
      var KEY      = 'jh_cuenta_fin_' + el.id;
      var fin      = parseInt(sessionStorage.getItem(KEY) || '0', 10);
      if (!fin || fin < Date.now()) {
        fin = Date.now() + horas * 3600 * 1000;
        sessionStorage.setItem(KEY, fin);
      }
      var tiempoEl = el.querySelector('.jh-cuenta-regresiva__tiempo');
      if (!tiempoEl) return;

      function tick() {
        var diff = fin - Date.now();
        if (diff <= 0) { tiempoEl.textContent = '00:00:00'; return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        tiempoEl.textContent = [h, m, s].map(function (n) {
          return String(n).padStart(2, '0');
        }).join(':');
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* ============================================================
     6. FAQ ACORDEÓN
     ============================================================ */
  function iniciarFAQ() {
    document.querySelectorAll('.jh-faq').forEach(function (contenedor) {
      var items = contenedor.querySelectorAll('.jh-faq-item');

      items.forEach(function (item) {
        var btn   = item.querySelector('.jh-faq__q');
        var panel = item.querySelector('.jh-faq__a');
        if (!btn || !panel) return;

        btn.addEventListener('click', function () {
          var estaAbierto = item.classList.contains('is-open');

          /* Cierra todos */
          items.forEach(function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('.jh-faq__q');
            var p = i.querySelector('.jh-faq__a');
            if (b) b.setAttribute('aria-expanded', 'false');
            if (p) p.setAttribute('hidden', '');
          });

          /* Abre este si estaba cerrado */
          if (!estaAbierto) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.removeAttribute('hidden');
          }
        });
      });
    });
  }

  /* ============================================================
     INICIALIZACIÓN — espera al DOM
     ============================================================ */
  function init() {
    iniciarGaleria();
    iniciarStickyAtc();
    iniciarPestanas();
    iniciarCuentas();
    iniciarFAQ();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
